import  { Toaster } from 'react-hot-toast';
import './App.css';
import { Route,BrowserRouter, Routes } from 'react-router-dom';
import Navbar from './Navbar';
import Main from './Main';
import Login from './Login';
import Register from './Register';
import { AuthProvider } from './AuthProvider';
import { Helmet } from 'react-helmet';
function App() {


  return (
    <div className="main1-container">
      <Helmet>
        <title>URL Shortener - Free & Fast Link Shortening</title>
        <meta name="description" content="URL Shortenerr is a free tool to create short, trackable links. Simple, secure, and fast." />
        <meta name="keywords" content="URL shortener, short links, free URL shortener, link tracker,urlshortenerr,free urlshortener" />
        <meta name="author" content="URL Shortener" />

        {/* Social Media Preview */}
        <meta property="og:title" content="URL Shortener" />
        <meta property="og:description" content="Create and manage short links easily with URL Shortener." />
        <meta property="og:type" content="website" />
       
<meta property="og:url" content="https://urlshortenerr.vercel.app/" />

<meta property="og:image" content="https://urlshortenerr.vercel.app/og-logo.png" />
      </Helmet>
        <AuthProvider >

    <Navbar />

   <div> <Toaster/></div>
    <Routes>
    <Route path="/" element={<Main />} />

      <Route path="/Register" element={<Register />} />

      <Route path="/Login" element={<Login />} />
    </Routes>
    </AuthProvider >
  </div>
  );
}

export default App;
